import { PdfViewerThumbnail } from './PdfViewerThumbnail'

import * as styles from './PdfViewerThumbnails.module.css'

function PdfViewerThumbnails({
  activePage,
  className = styles.PdfViewerThumbnails,
  pdfDocument,
  rotation,
  onSelectPage,
}) {
  return (
    <div className={className}>
      {Array.from({ length: pdfDocument.numPages }, (_, index) => {
        const pageNumber = index + 1

        return (
          <PdfViewerThumbnail
            isActive={pageNumber === activePage}
            key={pageNumber}
            pageNumber={pageNumber}
            pdfDocument={pdfDocument}
            rotation={rotation}
            onSelectPage={onSelectPage}
          />
        )
      })}
    </div>
  )
}

export default PdfViewerThumbnails
